var map = {
	"./all_ag_c.tif": 223,
	"./all_road_c.tif": 224,
	"./herders_c.tif": 225,
	"./lulc_modis.tif": 226,
	"./mine_c.tif": 227,
	"./nightlight_c.tif": 228,
	"./railways_c.tif": 229,
	"./urban_c.tif": 230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 222;